import * as React from 'react';

import {
  CartesianGrid,
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  Tooltip,
  Area
} from 'recharts';

import { DataPoint } from '../providers/TrackingDataProvider';
import { timestampToString, floatToString } from '../utils';
import { Paper } from '@material-ui/core';

interface TooltipProps {
  type?: string;
  payload?: any[];
  label?: string;
  active?: boolean;
}

class CustomTooltip extends React.Component<TooltipProps> {
  render() {
    const { active, payload } = this.props;

    const data =
      payload &&
      payload.length &&
      payload[0];

    const thumb =
      data &&
      data.payload &&
      data.payload.thumbnailUrl;

    if (active) {
      return (
        <Paper>
          <p className="label">NDVI: {floatToString(data && data.value, 2)}</p>
          <img src={thumb} />
        </Paper>
      );
    }

    return null;
  }
}

interface Props {
  width: string | number;
  height: string | number;
  data: DataPoint[];
}

export default class TrackingChart extends React.Component<Props> {
  render() {
    const { width, height, data } = this.props;

    return (
      <ResponsiveContainer width={width} height={height}>
        <AreaChart
          width={800}
          height={400}
          data={data}
          style={{ fontFamily: 'roboto' }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="date"
            tickFormatter={t => timestampToString(t)}
            type="number"
            domain={['dataMin', 'dataMax']}
          />
          <YAxis
            tickFormatter={t => floatToString(t, 2)}
            allowDataOverflow={false}
            domain={['0', 'auto']}
            type="number"
          />

          <Tooltip content={<CustomTooltip />} />

          <Area
            dataKey="meanNdvi"
            stroke="#83a56a"
            fill="#add88c"
            strokeWidth={3}
            animationDuration={300}
          />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrackingChart.tsx